import { normalize } from '../../utils/normalize'

import { SAVE_ANSWER, SAVED_ANSWER, RECEIVE_ANSWERS, DELETE_ANSWER, DELETED_ANSWER } from './actions'

export const answers = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_ANSWERS:
            return Object.assign({}, state, normalize(state, action.answers))

        case SAVE_ANSWER:
            return Object.assign({}, state, normalize(state, [{ ...action.answer, updating: true }]))

        case SAVED_ANSWER:
            const newSavedState = Object.assign({}, state, normalize(state, [{ ...action.answer, updating: false }]))
            const { prevId } = action
            if (prevId && prevId !== action.answer.id && newSavedState[prevId])
                delete newSavedState[prevId]
            return newSavedState

        case DELETE_ANSWER:
            return Object.assign({}, state, normalize(state, [{ ...action.answer, deleting: true }]))

        case DELETED_ANSWER:
            const newDeletedState = { ...state }
            delete newDeletedState[action.answer.id]
            return newDeletedState

        default:
            return state
    }
}


export const selectAnswersByQuestion = (state, question_id) => {
    return Object.keys(state.answers)
        .map(id => state.answers[id])
        .filter(a => a.question_id === question_id)
}

export const selectAnswer = (state, answerId) => state.answers[answerId]


// WEBPACK FOOTER //
// ./src/reducers/answers/index.js